import React, { useState, useEffect } from "react"
import { ProGallery } from 'pro-gallery';
import styled from "styled-components"
import Lightbox from 'react-image-lightbox';

/**
 * Using the Wix Pro Gallery component: https://github.com/wix/pro-gallery/tree/v3.1.38
 */

const GalleryWrapper = styled.div`
	min-height: 100vh;
`

export default function Gallery({ items }) {
	const [width, setWidth] = useState(null);
	const [imageInFocus, setImageInFocus] = useState(null);

	useEffect(() => {
		const updateDimensions = () => {
			setWidth(window.innerWidth);
		};

		window.addEventListener('resize', updateDimensions);
		updateDimensions();
	})

	if (!width) {
		return <GalleryWrapper />;
	}

	// The options of the gallery (from the playground current state)
	const options = {
		galleryLayout: -1,
	};

	const container = {
		width: width,
		height: 700
	};

	// Listens to the ITEM_CLICKED event to open the lightbox
	const eventsListener = (eventName, eventData) => {
		if (eventName === "ITEM_CLICKED") {
			setImageInFocus(eventData.idx);
		}
	};

	// The scrollingElement is usually the window, if you are scrolling inside another element, suply it here
	const scrollingElement = window;

	/**
	 * Uses https://github.com/frontend-collective/react-image-lightbox
	 */
	const lightboxComponent = () => {
		if (!imageInFocus) {
			return null;
		}
		return <Lightbox
			mainSrc={items[imageInFocus].fullUrl}
			mainSrcThumbnail={items[imageInFocus].placeholderUrl}
			onCloseRequest={() => setImageInFocus(null) }
			nextSrc={items[(imageInFocus + 1) % items.length].fullUrl}
			prevSrc={items[(imageInFocus + items.length - 1) % items.length].fullUrl}
			onMovePrevRequest={() =>
				setImageInFocus((imageInFocus + items.length - 1) % items.length)
			}
			onMoveNextRequest={() =>
				setImageInFocus((imageInFocus + 1) % items.length)
			}
			imageLoadErrorMessage={<div>Loading...</div>}
		/>
	}

	return (
		<GalleryWrapper>
			{lightboxComponent()}
			<ProGallery
				items={items}
				options={options}
				container={container}
				eventsListener={eventsListener}
				scrollingElement={scrollingElement}
			/>
		</GalleryWrapper>
	);
}
